/**
 * @deprecated
 */
export enum ClvRequestMethod {
  GET = 'GET', POST = 'POST', PUT = 'PUT', DELETE = 'DELETE'
}
